import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { type SxProps } from '@mui/system'
import { KNQuoteSubmittedIcon, KNQuoteRejectedIcon, KNQuoteIcon, KNQuoteClosedIcon } from 'components/KNIcon/KNMaterialIcon'
import { useQuotesView } from 'context/QuotesViewContext'
import { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import PredefinedFiltersItem from 'screens/TripDashboard/PredefinedFiltersItem'
import { type QuoteRequestCounters, QuoteStatus } from './Quotes.types'

export interface QuotePredefinedFiltersProps {
  counters: QuoteRequestCounters
  sx?: SxProps
}

const QuotePredefinedFilters = ({ counters, sx }: QuotePredefinedFiltersProps): ReactElement => {
  const { t } = useTranslation()
  const { setFilters } = useQuotesView()
  const filters = [
    {
      name: QuoteStatus.OPEN,
      label: t('screens.cs.quotes.statuses.OPEN'),
      icon: <KNQuoteIcon />,
      tooltip: t('screens.cs.quotes.predefined_filters.open_tooltip'),
    },
    {
      name: QuoteStatus.SUBMITTED,
      label: t('screens.cs.quotes.statuses.SUBMITTED'),
      icon: <KNQuoteSubmittedIcon />,
      tooltip: t('screens.cs.quotes.predefined_filters.submitted_tooltip'),
    },
    {
      name: QuoteStatus.REJECTED,
      label: t('screens.cs.quotes.statuses.REJECTED'),
      icon: <KNQuoteRejectedIcon />,
      tooltip: t('screens.cs.quotes.predefined_filters.rejected_tooltip'),
    },
    {
      name: QuoteStatus.CLOSED,
      label: t('screens.cs.quotes.statuses.CLOSED'),
      icon: <KNQuoteClosedIcon />,
      tooltip: t('screens.cs.quotes.predefined_filters.closed_tooltip'),
    },
  ]

  return (
    <Box
      sx={{
        padding: 1,
        ...sx,
      }}
    >
      <Grid container spacing={{ xs: 1, md: 2 }} justifyContent="center">
        {filters.map((filter) => (
          <Grid size={{ xs: 6, sm: 4, md: 1 }} key={filter.name}>
            <PredefinedFiltersItem
              label={filter.label}
              icon={filter.icon}
              counter={counters[filter.name] ?? 0}
              tooltip={filter.tooltip}
              onClick={() => {
                setFilters({
                  status: [filter.name],
                })
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default QuotePredefinedFilters
